module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_01 (1).8e55367f.png";